export default __webpack_public_path__ + "static/media/pushyy-text.5d49ee9e.png";